import { create } from "../../../common/utils/zustand_state_manager";
import { IAuthService } from "../../../features/auth/data/services/auth_service";
import { AuthService } from "../../../features/auth/data/services/auth_service_impl";

/**
 * useAuthServices
 */

type ServicesState = {
  authService: IAuthService,
};

export const useAuthServices = create<ServicesState>(() => ({
  authService: new AuthService(),
}));